var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main-top"},[_c('div',{staticClass:"main-map"},[_c('aMap')],1),_vm._v(" "),_c('div',{staticClass:"deal-center-info"},[_c('deal-center-info')],1)]),_vm._v(" "),_c('div',{staticClass:"main-center"},[_c('main-center',{attrs:{"activeName":_vm.activeName}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }